import { useContext, useEffect, useState } from 'react';
import styles from './ScrapingOverview.module.css';
import {
    addExpectedHitsToLog,
    batchResolveSearchLog,
    checkSearchLog,
    createNewSearchIssue,
    getAnonymizedSearches,
    getBloatedLogs,
    getSearchIssue,
    testElastic,
} from '../../services/apiService';
import Button, { ButtonType } from '../general-components/Button';
import Modal from '../manage-user/Modal';
import SelectItem from '../general-components/SelectItem';
import EditSearchIssue from '../search-issues/EditSearchIssue';
import OverlayWindow from '../ui-components/OverlayWindow';
import React from 'react';
import AuthContext from '../../store/auth-context';
import FormInput from '../general-components/FormInput';
import SearchResultRow from './SearchResultRow';

const ScrapingOverview: React.FC = () => {
    const [searches, setSearches] = useState<any[]>([]);
    const [isDeletingSearch, setIsDeletingSearch] = useState<boolean>(false);
    const [deletingId, setDeletingId] = useState<string>('');
    const [issue, setIssue] = useState<any>();
    const [toResolve, setToResolve] = useState<string[]>([]);
    const [successfulResolve, setSuccessfulResolve] = useState(false);
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const [updateOccurred, setUpdateOccurred] = useState(false);
    const [bloatedLogs, setBloatedLogs] = useState<any[]>([]);
    const [showBloatedLogs, setShowBloatedLogs] = useState(false);
    const [testResults, setTestResults] = useState<any>();

    const [testSearchLogs, setTestSearchLogs] = useState<any[]>([]);
    const [showTestSearchLogs, setShowTestSearchLogs] = useState(false);

    const context = useContext(AuthContext);

    const onDelete = async (e: MouseEvent) => {
        e.preventDefault();
        await checkSearchLog(deletingId);
        setSearches(searches.filter((s) => s._id !== deletingId));
    };

    const getData = async () => {
        const s = await getAnonymizedSearches();
        const b = await getBloatedLogs();

        setTestSearchLogs(
            s.concat(b).filter((s: any) => s.expectedHits !== undefined)
        );

        setSearches(s);
        setBloatedLogs(b);
    };

    useEffect(() => {
        setSuccessfulResolve(false);
        getData();
    }, [successfulResolve, updateOccurred]);

    const handleUpdate = () => {
        // setUpdateOccurred(true);
        setIsOverlayOpen(false);
        setIssue('');
        getData();
    };

    const handleCreateIssue = async (searchLogId: string) => {
        const user = await context.getAllInfo();

        const newSearchIssue = await createNewSearchIssue(
            searchLogId,
            user.user._id
        );
        const searchIssueData = await getSearchIssue(newSearchIssue.message);
        setIssue(searchIssueData.message);
        setIsOverlayOpen(true);
    };

    const handleMarkForResolve = (issueId: string) => {
        if (!toResolve.includes(issueId)) {
            setToResolve((prev) => {
                return [...prev, issueId];
            });
        } else {
            return setToResolve((prev) => {
                return prev.filter((id) => id !== issueId);
            });
        }
    };

    const handleMassResolve = async () => {
        const resolveStatus = await batchResolveSearchLog(toResolve);
        setSearches((prev) => {
            return prev.filter((item) => !item.isResolved);
        });
        setToResolve([]);
        setSuccessfulResolve(true);
    };

    const handleTestElastic = async () => {
        const logs = await testElastic();
        setTestResults(logs);
    };

    return (
        <div className={styles.wrapper}>
            <div>
                <Button onClick={handleTestElastic} type={ButtonType.submit}>
                    Test Elastic
                </Button>
                {testResults && (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                        }}
                    >
                        {testResults.map((result: any) => (
                            <div key={result.functionName}>
                                <p>Function: {result.functionName}</p>
                                <p>Total: {result.total}</p>
                                <p>Success Rate: {result.successRate}</p>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '10px',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '10px',
                                        }}
                                    >
                                        <p>
                                            High:{' '}
                                            {result.unexpectedHighHits.length}
                                        </p>
                                        <p>
                                            Zero but high:{' '}
                                            {result.zeroButHigh.length}
                                        </p>
                                        <p
                                            style={{
                                                width: '300px',
                                                // overflowX: 'auto',
                                            }}
                                        >
                                            High:{' '}
                                            {result.unexpectedHighHits.map(
                                                (term: any) => (
                                                    <div>
                                                        <hr
                                                            style={{
                                                                border: '1px solid white',
                                                            }}
                                                        />
                                                        <p
                                                            key={
                                                                term.searchTerm
                                                            }
                                                        >
                                                            {term.result}:
                                                            {term.expectedHits}{' '}
                                                            -{term.searchTerm}
                                                        </p>
                                                    </div>
                                                )
                                            )}
                                        </p>
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '10px',
                                        }}
                                    >
                                        <p>
                                            Zero:{' '}
                                            {result.unexpectedZeroHits.length}
                                        </p>
                                        <p
                                            style={{
                                                width: '300px',
                                                // overflowX: 'auto',
                                            }}
                                        >
                                            Zero:{' '}
                                            {result.unexpectedZeroHits.map(
                                                (term: any) => (
                                                    <div>
                                                        <hr />
                                                        <p
                                                            key={
                                                                term.searchTerm
                                                            }
                                                        >
                                                            {term.searchTerm}
                                                        </p>
                                                    </div>
                                                )
                                            )}
                                        </p>
                                        <p>Low: {result.highButLow.length}</p>
                                        <p
                                            style={{
                                                width: '300px',
                                                // overflowX: 'auto',
                                            }}
                                        >
                                            Low:{' '}
                                            {result.highButLow.map(
                                                (term: any) => (
                                                    <div>
                                                        <hr />
                                                        <p
                                                            key={
                                                                term.searchTerm
                                                            }
                                                        >
                                                            {term.result}:
                                                            {term.expectedHits}{' '}
                                                            -{term.searchTerm}
                                                        </p>
                                                    </div>
                                                )
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <div className={styles.overview}>
                <div>
                    <div className={styles.bloatedLogsHeader}>
                        <h2>Test Search Logs</h2>
                        <Button
                            small={true}
                            onClick={() =>
                                setShowTestSearchLogs(!showTestSearchLogs)
                            }
                            type={ButtonType.primary}
                        >
                            {showTestSearchLogs
                                ? 'Hide Test Search Logs'
                                : 'Show Test Search Logs'}
                        </Button>
                    </div>
                    {showTestSearchLogs && (
                        <div className={styles.bloatedLogsContainer}>
                            <div className={styles.tableContainer}>
                                <div className={styles.tableHeader}>
                                    <div className={styles.headerItem}>
                                        Search Term
                                    </div>
                                    <div className={styles.headerItem}>
                                        User
                                    </div>
                                    <div className={styles.headerItem}>
                                        Date
                                    </div>
                                    <div className={styles.headerItem}>
                                        Results
                                    </div>
                                    <div className={styles.headerItem}></div>
                                    <div className={styles.headerItem}></div>
                                    <div className={styles.headerItem}></div>
                                    <div className={styles.headerItem}></div>
                                    <div className={styles.headerItem}></div>
                                </div>
                                <div className={styles.tableBody}>
                                    {testSearchLogs.map((log) => (
                                        <SearchResultRow
                                            key={log._id}
                                            search={log}
                                            toResolve={toResolve}
                                            onExpectedHitsChange={
                                                addExpectedHitsToLog
                                            }
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div>
                    <div className={styles.bloatedLogsHeader}>
                        <h2>Bloated Logs</h2>
                        <Button
                            small={true}
                            onClick={() => setShowBloatedLogs(!showBloatedLogs)}
                            type={ButtonType.primary}
                        >
                            {showBloatedLogs ? 'Hide' : 'Show'} Bloated Logs
                        </Button>
                    </div>
                    {showBloatedLogs && (
                        <div className={styles.bloatedLogsContainer}>
                            <div className={styles.tableContainer}>
                                <div className={styles.tableHeader}>
                                    <div className={styles.headerItem}>
                                        Search Term
                                    </div>
                                    <div className={styles.headerItem}>
                                        User
                                    </div>
                                    <div className={styles.headerItem}>
                                        Date
                                    </div>
                                    <div className={styles.headerItem}>
                                        Results
                                    </div>
                                    <div className={styles.headerItem}></div>
                                    <div className={styles.headerItem}></div>
                                    <div className={styles.headerItem}></div>
                                    <div className={styles.headerItem}></div>
                                    <div className={styles.headerItem}></div>
                                </div>
                                <div className={styles.tableBody}>
                                    {bloatedLogs.map((log) => (
                                        <SearchResultRow
                                            key={log._id}
                                            search={log}
                                            toResolve={toResolve}
                                            onExpectedHitsChange={
                                                addExpectedHitsToLog
                                            }
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className={''}>
                    <h1>Recent Searches</h1>
                    {toResolve.length <= 0 ? (
                        ''
                    ) : (
                        <Button
                            onClick={handleMassResolve}
                            type={ButtonType.submit}
                        >
                            Resolve Selected
                        </Button>
                    )}
                    <div className={styles.tableContainer}>
                        <div className={styles.tableHeader}>
                            <div className={styles.headerItem}>Search Term</div>
                            <div className={styles.headerItem}>User</div>
                            <div className={styles.headerItem}>Date</div>
                            <div className={styles.headerItem}>Results</div>
                            <div className={styles.headerItem}></div>
                            <div className={styles.headerItem}></div>
                            <div className={styles.headerItem}></div>
                            <div className={styles.headerItem}></div>
                            <div className={styles.headerItem}></div>
                        </div>
                        <div className={styles.tableBody}>
                            {searches
                                .filter((item) => !item.isResolved)
                                .map((search) => (
                                    <SearchResultRow
                                        key={search._id}
                                        search={search}
                                        toResolve={toResolve}
                                        onCreateIssue={handleCreateIssue}
                                        onMarkForResolve={handleMarkForResolve}
                                        onExpectedHitsChange={
                                            addExpectedHitsToLog
                                        }
                                    />
                                ))}
                        </div>
                    </div>
                </div>

                {isDeletingSearch && (
                    <Modal
                        info={{
                            title: 'Delete',
                            message:
                                'Are you sure you want to delete this entry?',
                        }}
                    >
                        <Button
                            onClick={(e: MouseEvent) => {
                                onDelete(e);
                                setIsDeletingSearch(false);
                            }}
                            type={ButtonType.cancel}
                            small={true}
                        >
                            Delete
                        </Button>
                        <Button
                            onClick={() => setIsDeletingSearch(false)}
                            type={ButtonType.tietary}
                            small={true}
                        >
                            Cancel
                        </Button>
                    </Modal>
                )}
            </div>
            {isOverlayOpen && (
                <OverlayWindow
                    close={() => {
                        setIssue('');
                        setIsOverlayOpen(false);
                    }}
                >
                    <EditSearchIssue
                        issue={issue}
                        onUpdateOccurred={handleUpdate}
                    />
                </OverlayWindow>
            )}
        </div>
    );
};

export default ScrapingOverview;
